module.exports = __webpack_public_path__ + "static/img/bg-premium.6c638f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-premium.jpg
// module id = B6TU
// module chunks = 1